import { DEFAULT_PAGE_SIZE } from "common/config";
import { DocListState } from "../../models/document-list-state.model";

const initialDocListState: DocListState = {
  currentPageDetails: {
    page: 1,
    size: DEFAULT_PAGE_SIZE,
    sort: "",
    dir: "",
    search: ""
  }
};

export { initialDocListState };
